<template>
  <footer class="cart">
    <div class="overlay" v-show="!hideMealList" @click="hideMealList = true"></div>
    <div
        v-if="(storeDetail.status == 1 || storeDetail.status == 2) && !(storeDetail.personal == 0 && storeDetail.in_scope == 2)">
      <div class="cartList" :class="{ hide: hideMealList }">
        <div class="message" v-if="storeDetail.store_rebate_count > 0">限{{
            storeDetail.store_rebate_count
          }}份优惠，超出以原价计算
        </div>
        <div class="top">
          <div class="label">购物车</div>
          <!--          todo 这里应当只在未开启多篮子的情况下展示  -->
          <div class="lefttip" v-if="!enableBasket">
            <div v-if="shopOptions.store_type == 4">占碗容量：{{ calculatorBasketPct(null) }}</div>
          </div>
          <img src="@/assets/images/shop/rubbish.png" alt class="rubbish"/>
          <div class="clearCart" @click="updateCart('clear')">清空</div>
        </div>
        <div class="mealObj" :class="{ hide: hideMealList }">
          <div class="basket" v-for="(basket, i ) in baskets">

            <div class="basketHead" v-if="enableBasket">
              <div @click="changeSelectedBasket(i)">
                <div class="radio basketRadio " :class="{ selected: currentBasketIndex == i }"></div>
                <img class="basketImg" src="@/assets/images/shop/basket.png" alt/>
              </div>
              <div class="basketText" v-html="i + 1 + '号篮子'"></div>
              <div class="basketTip" v-if="false">
                选用后，加购餐品将自动放入该篮子
              </div>
              <div class="basketPct">
                占碗容量 {{ calculatorBasketPct(i) }}
              </div>
            </div>

            <div class="mealItem" v-for="(item, index) in basket.mealList" :key="index"
                 :class="{ disabled: item.disabled }">
              <div class="name">
                {{ item.meal.name }}
                <div class="label">{{ calcuShowTag(item.meal) }}</div>
              </div>
              <div class="lefttip" >
                占碗容量：{{ calculatorPct(item.meal.shp_pct * item.amount) }}
              </div>
              <div class="price">￥{{ item.realPrice }}</div>
              <div class="btn sub" @click="updateCart('sub', item, i)">-</div>
              <div class="num">{{ item.amount }}</div>
<!--              item.amount < item.meal.storage -->
              <div class="btn plus " v-if="isEnablePlus(item.meal_id) && item.meal.is_must != 1"
                   :class="{ disabled: item.meal.is_must }" @click="updateCart('plus', item, i)">
                +
              </div>
              <div class="btn plus testBtn2"  :style="enable" v-else>+</div>
            </div>
          </div>


          <!--          todo 样式抽出-->
          <!--          只有在最后一个篮子不为空的情况下，才展示新篮子-->
          <div class="basket">

            <div class="basketHead" v-if="enableBasket && baskets[baskets.length - 1].mealList.length > 0">

              <div @click="changeSelectedBasket(baskets.length)">
                <div class="radio basketRadio " :class="{ selected: currentBasketIndex == baskets.length }"></div>
                <img class="basketImg" src="@/assets/images/shop/basket.png" alt/>
              </div>
              <div class="basketText" v-html="baskets.length + 1 + '号篮子'"></div>
              <div class="basketTip" v-if="false">
                选用后，加购餐品将自动放入该篮子
              </div>
            </div>
          </div>

          <div class="mealItem" v-if="packagePrice != 0">
            <div class="name">餐盒费</div>
            <div class="price">￥{{ packagePrice }}</div>
          </div>

        </div>

      </div>
      <div class="cartContainer" :class="{ disabled: totalAmount == 0 }">
        <div class="cartIcon" @click="toggleMealList">
          <div class="count" v-if="totalAmount > 0">{{ totalAmount }}</div>
        </div>
        <div class="priceNode">
          <div class="price">￥{{ totalPrice }}</div>
          <div class="label">
            <template v-if="storeDetail.personal == 1">
              可自提
              <template v-if="$root.type == 'package'">
                /
              </template>
            </template>
            <template v-if="storeDetail.personal != 2 && $root.type == 'package'">
              配送需配送费
              <template v-if="enough">
                <template
                    v-if="storeDetail.rebate && storeDetail.rebate != '0.00' && storeDetail.rebate != storeDetail.price">
                  ￥{{ storeDetail.rebate }}
                  <span class="through">￥{{ storeDetail.price }}</span>
                </template>
                <template v-else>
                  ￥{{ storeDetail.price || '0' }}
                </template>
              </template>
              <template v-else>
                <template
                    v-if="storeDetail.un_rebate && storeDetail.un_rebate != '0.00' && storeDetail.un_rebate != storeDetail.un_price">
                  ￥{{ storeDetail.un_rebate }}
                  <span class="through">￥{{ storeDetail.un_price }}</span>
                </template>
                <template v-else>
                  ￥{{ storeDetail.un_price || '0' }}
                </template>
              </template>
            </template>
          </div>

        </div>
        <div class="btn" @click="getStoreStatus(false)">去结算</div>
      </div>
    </div>
    <div class="error" v-else-if="storeDetail.personal == 0 && storeDetail.in_scope == 2">本店超出配送范围</div>
    <div class="error" v-else>{{ {'0': '休息中', '2': '准备中', '3': '已售罄'}[storeDetail.status] }}</div>
  </footer>
</template>

<script>
import {
  MessageBoxImageType,
  StoreMealObject,
  SelectedStoreDetail,
  OrderConfirmSelectedCoupon,
  OrderConfirmCache,
  MemberSelectedAddress,
  StoreShowTakeMessageBox
} from "@/constants";
import {
  addMeal,
  verifyCart,
  verifyAnchor,
  in_array,
  getBackUpMax
} from "@/interface/shop.js";
import $localStorage from "@/utils/localStorage.js";
import checkPhoneMixin from "@/mixins/checkPhone.js";
import {instance as Toast} from "@/plugins/toast/";
import {SHP_INTERFACE_BASE_URL} from "@/config/config";
import qs from "qs";
import Decimal from 'decimal.js';

export default {
  mixins: [checkPhoneMixin],
  props: {
    timeOptions: {
      type: Object,
      required: true
    },
    shopOptions: {
      type: Object,
      required: true
    },
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 篮子
      enableBasket: false,
      currentBasketIndex: 0,
      baskets: [
        {
          mealList: [],
        },
      ],
      // 库存数量映射
      storageMap:{},
      mealStorage: {},

      storeDetail: {},
      mealObj: {},
      totalShpPct: 0,
      hideMealList: true,
      // 必点
      newStore: [],
      //备餐上限及备餐分类数组
      backupMax: 0,
      backupArray: [],
      enable: "pointer-events: none; background-color:#a6a6a6;"
    };
  },
  computed: {
    mealObjToList() {
      let list = [],
          sortList = [],
          rebate_count = this.storeDetail.store_rebate_count,
          // 单品优惠数量
          mealAmountObj = {};

      Object.keys(this.mealObj)
          .filter(key => !['parter', 'basket'].includes(key))
          .forEach(v => {
            let tag = [];

            tag = tag.concat(this.mealObj[v].checkedProperty.map(v2 => v2.title));
            tag = tag.concat(this.mealObj[v].checkedParter.map(v2 => v2.name));
            this.mealObj[v].tag = tag.join("/");
            this.mealObj[v].realPrice = parseFloat(
                (
                    this.mealObj[v].price * this.mealObj[v].amount +
                    this.mealObj[v].parterPropertyPrice * this.mealObj[v].amount
                ).toFixed(2)
            );

            list.push(this.mealObj[v]);
            // 单品优惠数量
            mealAmountObj[this.mealObj[v].meal_id] = this.mealObj[v].meal.rebate_amount;
          });

      // 先选出有优惠的商品，再按优惠价格排序，最后判断哪些商品有优惠，优惠几个
      sortList = list
          .filter(v => v.hasDiscount)
          .sort((a, b) => b.discount - a.discount)
          .map(v => {
            let useRebate = 0;
            // 一个id下的所有搭配商品共享一个优惠数量
            useRebate =
                v.amount > mealAmountObj[v.meal_id]
                    ? mealAmountObj[v.meal_id]
                    : v.amount;
            // 如果门店有优惠数量，则最大数量为门店优惠数量
            if (rebate_count > 0) {
              if (useRebate > rebate_count) {
                useRebate = rebate_count;
                rebate_count = 0;
              } else {
                rebate_count -= useRebate;
              }
            }
            // 如果门店优惠数量是0，则使用餐品自身的优惠数量
            else if (rebate_count == 0) {
              // 不做操作
            }
            // 减去使用了的优惠数量
            mealAmountObj[v.meal_id] -= useRebate;
            v.realPrice = parseFloat(
                (
                    useRebate * v.rebate_price +
                    (v.amount - useRebate) * v.price +
                    v.parterPropertyPrice * v.amount
                ).toFixed(2)
            );
            return v;
          });
      list = list.sort((a, b) => {
        a.sortIndex - b.sortIndex;
      });

      list.forEach(item => {
        let key = item.key;
        this.baskets.forEach(basket => {
          if (basket && basket.mealList) {
            basket.mealList.forEach(meal => {
              if (meal.key == key) {
                meal.realPrice = item.realPrice;
              }
            })
          }
        })
      });

      this.baskets = JSON.parse(JSON.stringify(this.baskets));
      $localStorage.set(`baskets_${this.shopOptions.store_id}`, this.baskets)

      return {list, sortList};
    },
    cartList() {
      return this.mealObjToList.list;
    },
    packagePrice() {
      let price = 0;
      let cartList = [];
      if ((!cartList) || cartList.length < 1) {
        this.baskets.forEach(item => {
          cartList = cartList.concat(item.mealList)
        })
      }
      cartList.forEach(v => {
        switch (v.meal.package_rule) {
          case 1:
            price += parseFloat(v.meal.package_price);
            break;
          case 2:
            price += parseFloat(v.meal.package_price) * v.amount;
            break;
        }
      });
      return price;
    },
    totalAmount() {
      let amount = 0;
      // 这里不再对 this.enableBasket 进行检查
      if (this.baskets) {
        this.baskets.forEach(v => {
          if (v && v.mealList) {

            v.mealList.forEach(v2 => {
              amount += v2.amount;
            })
          }
        });
      } else {
        // this.cartList 基本上已改为适配 baskets 的形式 else 一般不会执行
        this.cartList.forEach(v => {
          amount += v.amount;
        });
      }
      return amount;
    },
    totalPrice() {
      let price = 0;

        if (this.baskets) {
          this.baskets.forEach(v => {
            if (v && v.mealList) {
              v.mealList.forEach(v2 => {
                price += v2.realPrice;
              })
            }
          });
        }
      return price.toFixed(2);
    },
    enough() {
      return this.totalPrice > parseFloat(this.storeDetail.min_price);
    }
  },
  created() {

  },
  mounted() {
    this.loadData();
  },
  methods: {
    calcuShowTag(meal) {
      if ((!meal.parter) || (!meal.parter[0]) || (!meal.parter[0][0])) {
        return '';
      }
      // 搭配
      let parters = meal.parter[0].flat(1).filter(item => item.checked == 1);

      let parterName = parters.map(item => item.name).join("&")

      let parterStr = ''
      let propArray = parters
          .reduce((acc, cur) => {
            acc.push(cur.parter_property);
            return acc;
          }, [])
          .flat(1);
      if (propArray.length > 0) {
        parterStr = propArray.reduce((acc, prop) => {
          // 只保留选中的子项
          let checkedItems = prop.childs.filter(item => item.checked == 1);
          // 将子项的标题连接成字符串，并用/分隔
          let subStr = checkedItems.map(item => item.title).join('/');
          // 在每个子字符串后面加上/
          return acc + subStr + '/';
        }, '');
        // 去掉最后一个/
        parterStr = parterStr.slice(0, -1);
      }

      // 规格
      let properties = meal.property

      let propertyStr = '';
      let propertyStrArray = [];
      for (let prop of properties) {
        let propChildStr = prop.childs.filter(item => item.checked == 1)
            .map(item => item.title)
            .join(' ');
        propertyStrArray.push(propChildStr);
      }
      propertyStr = propertyStrArray.join(' ');
      if (propertyStrArray.length > 0) {
        propertyStr = '(' + propertyStr + ')'
      }
      return `${parterName} ${parterStr} ${propertyStr}`
    },
    changeSelectedBasket(index) {
      this.currentBasketIndex = index;
    },
    showmsg() {
      this.$msgbox.show({
        messageText: "必选品仅限选择一次！",
        confirmBtnText: "我知道了"
      });
      return false;
    },
    isEnablePlus(mealId) {
      let storage = this.storageMap[mealId]
      let maxStorage = this.mealStorage[mealId];
      return storage < maxStorage;
    },
    //获取备餐分类及最大限制
    getbackupmax() {
      let data = {store_id: this.shopOptions.store_id};
      getBackUpMax(data).then(data => {
        this.backupArray = data.data.shp_backup;
        this.backupMax = data.data.max_limit;
      });
    },
    // 必选品
    anchor() {
      if (this.totalAmount != 0) {
        let mealId = [];
        let hasAmount = 0;

        let cartList = [];
        if ((!cartList) || cartList.length < 1) {
          this.baskets.forEach(item => {
            cartList = cartList.concat(item.mealList)
          })
        }

        cartList.forEach(v => {
          if (this.shopOptions.store_type == 4) {
            hasAmount += v.meal.shp_pct * v.amount;
          }
          mealId.push(v.meal_id);
        });
        this.totalShpPct = hasAmount;

        verifyAnchor(mealId, this.shopOptions.store_id).then(i => {
          this.newStore = i.result.must_list;
          if (this.newStore == "") {
            this.$emit("verifyCartCallback", "");
          } else {
            this.$emit("verifyCartCallback", this.newStore);
          }
        });

      } else {
        this.$emit("verifyCartCallback", "");
      }
    },
    toggleMealList() {
      if (this.baskets.length == 1 && this.baskets[0].mealList.length == 0) {
        return
      }
      this.hideMealList = !this.hideMealList;
    },
    getStoreStatus(skipToConfirm) {
      let data = {
        api_name: "shopStatus",
        store_id: this.shopOptions.store_id,
      };
      fetch(SHP_INTERFACE_BASE_URL, {
        method: "POST",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        body: qs.stringify(data)
      })
          .then(response => response.json())
          .then(data => {
            if (data.code == 200) {
              if (data.data.status == 2) {
                this.$msgbox.show({
                  imageType: MessageBoxImageType.CanteenError,
                  messageText: `<div style="text-align:center">
                                <p style="color:#000;font-size:45px;font-weight:bold;margin:10px;">设备维护中</p>
                                <p style="color:#000;margin-bottom:10px;">给您带来不便，敬请谅解</p>
								<p style="color:#000;">📞 服务热线 400-007-7300</p>
								</div>`,
                  confirmBtnText: "我知道了",
                  showClose: false,
                  outsideTouchable: false,
                  confirmFn: () => {
                    window.history.back();
                  }
                });
              } else {
                let splitOrder = data && data.data && data.data.shop && data.data.shop.Shop && data.data.shop.Shop.split_order;
                // 1-按篮子拆分 2-按餐品拆分 3-不拆分工单
                splitOrder = splitOrder * 1 || 0;

                const enableBasket = splitOrder != 3;

                let cacheEnableBasket = JSON.stringify($localStorage.get(`baskets_enable_${this.shopOptions.store_id}`));
                let cacheEnable = 'false' !== cacheEnableBasket;
                if (cacheEnable !== enableBasket) {
                  // 如果篮子的开启与否与上一次记录的不一致 消除之前的篮子缓存 让用户重新添加
                  this.clear();
                }

                this.enableBasket = enableBasket;
                $localStorage.set(`baskets_enable_${this.shopOptions.store_id}`, JSON.parse(JSON.stringify(enableBasket)));
                if (!skipToConfirm) {
                  this.goToOrderConfirm();
                } else {
                  if (cacheEnable !== enableBasket) {
                    // 如果篮子的开启与否与上一次记录的不一致 消除之前的篮子缓存 让用户重新添加
                    this.clear();
                  }
                }
              }
            } else {
              Toast.show(data.msg);
            }
          });
    },
    goToOrderConfirm() {
      this.updateStorage();
      let arr = [];
      // 如果 cartList 为 空 ， 从 baskets 中取
      // let cartList = [];
      let allPct = [];
      let checkPct = this.shopOptions.store_type == 4;
      for (let i = 0; i < this.baskets.length; i++) {
        let basket = this.baskets[i];
        let basketAmount = new Decimal('0');
        if (basket && basket.mealList) {
          basket.mealList.forEach(v => {
            if (checkPct) {
              let mealPct = new Decimal(v.meal.shp_pct);
              let amount = new Decimal(v.amount);
              let pct = mealPct.times(amount);
              basketAmount = basketAmount.plus(pct);
            }

            let obj = {
              amount: v.amount,
              meal_id: v.meal.id,
              meal_name: v.meal.name,
              property_ids: v.checkedPropertyIds,
              price: v.realPrice,
              basket: v.basket,
              parter: v.parter,
            };
            arr.push(obj);
          })
          allPct[i] = {
            basketIndex: i,
            pct: basketAmount.toFixed(2)
          };
        }
      }

      // allPct 任一篮子超过1 则提示
      let exceedBasket = allPct.find(item => item.pct > 1);
      if (exceedBasket) {
        let messageText = this.enableBasket ? `${exceedBasket.basketIndex + 1}号篮子超过餐比容量上限。` : `餐盒容量已达上限`;
        this.$msgbox.show({
          messageText: messageText,
          confirmBtnText: "我知道了"
        });
        return false;
      }

      let data = {
        user_id: this.$root.user_id,
        store_id: this.shopOptions.store_id,
        type: this.$root.type,
        meal_id: arr
      };
      if (this.$root.type == "package" || this.$root.type == "personal") {
        data.date = this.timeOptions.date;
        data.start = this.timeOptions.start;
      }

      verifyCart(data).then(data => {
        if (data.result.type == 1) {
          $localStorage.set('orderInfoCache', JSON.parse(JSON.stringify(this.baskets)))
          $localStorage.del(OrderConfirmSelectedCoupon);
          $localStorage.del(OrderConfirmCache);

          // this.clear();

          window.location.href = `./orderConfirm.html${this.storeDetail.personal == 0 ? "?disabled_take=1" : ""}`;
        } else if (data.errcode == "-4") {
          this.$emit("verifyCartCallback", data.result.must_list);
          this.$msgbox.show({
            title: data.errmsg,
            confirmBtnText: "我知道了",
            confirmFn: () => {
              var str = window.location.href;
              str = str.substring(str.lastIndexOf("/") + 1);
              str = str.substring(0, str.lastIndexOf("."));
              if (str == "mealDetail") {
                window.history.back();
              }
            }
          });
        } else {
          let messageList = data.result.meal_list.map(v => {
            v.reason = [v.message];
            return v;
          });
          this.$msgbox.show({
            title: "以下商品无法购买",
            messageList,
            showCancelBtn: true,
            showConfirmBtn: data.result.type == 2,
            cancelBtnText: "重新选择",
            confirmBtnText: "删除并下单",
            cancelFn: () => {
              this.checkMealList("back", data.result.meal_list);
            },
            confirmFn: () => {
              this.checkMealList("del", data.result.meal_list);
            }
          });
        }
      });
    },
    checkMealList(type, mealList) {
      mealList.forEach(meal => {
        let mealKey = `${meal.id}_${meal.parter_id || ""}_${meal.property_ids ||
        ""}_${meal.parter_property_ids || ""}`;
        Object.keys(this.mealObj).forEach(v => {
          if (v == mealKey) {
            if (type == "del") {
              this.$delete(this.mealObj, v);
              this.updateStorage();
              if (this.totalAmount > 0) {
                $localStorage.del(OrderConfirmSelectedCoupon);
                $localStorage.del(OrderConfirmCache);
                window.location.href = `./orderConfirm.html${this.storeDetail.personal == 0 ? "?disabled_take=1" : ""
                }`;
              }
            } else if (type == "back") {
              this.mealObj[v].disabled = true;
              this.$set(this.mealObj, v, this.mealObj[v]);
              this.updateStorage();
              this.anchor();
              this.hideMealList = false;
            }
          }
        });
      });
    },
    updateBaskets() {
      let list = [];
      this.baskets.forEach(basket => {
        let bool = basket.mealList.some(meal => meal.amount > 0)
        if (bool) {
          list.push(basket);
        }
      })
      if (list.length < 1) {
        list = [
          {
            selected: true,
            mealList: [],
          },
        ]
      }
      this.baskets = list;
    },
    // 占碗容量 2位小数
    calculatorPct(num) {
      return num.toFixed(2)
    },
    /**
     * 计算篮子的占比
     * @param basketIndex 篮子的索引
     */
    calculatorBasketPct(basketIndex) {
      let hasAmount = 0;
      let cartList = [];

      if (basketIndex === undefined || basketIndex === null) {
        this.baskets.forEach(item => {
          cartList = cartList.concat(item.mealList)
        })
      } else {
        let basket = this.baskets[basketIndex];
        cartList = basket.mealList;
      }

      cartList.forEach(v => {
        // if (this.shopOptions.store_type == 4) {
        // }
          hasAmount += v.meal.shp_pct * v.amount;
      });

      return hasAmount.toFixed(2);
    },
    // 更新购物车
    updateCart(type, item, index) {
      switch (type) {
          // 新增商品
        case "addMeal":
          // 商品数量增加
        case "plus":
          this.checkPhone().then(() => {
            let data = {
              ...this.timeOptions,
              ...this.shopOptions,
              user_id: this.$root.user_id,
              meal_id: item.meal.id
            };
            addMeal(data, true).then(data => {
              if (data.errcode == "-4") {
                this.newStore = data.result.meal_list;
                return;
              }
              if (data.errcode == 0) {
                let addToNewBasket = false;
                // 价格重算相关对象 todo sub中有相同一份代码 需要封装
                let mealAmountObj = {};

                let originMealKey = `${item.meal_id}_${item.checkedParterIds ||
                    ""}_${item.checkedPropertyIds ||
                    ""}_${item.checkedParterPropertyIds || ""}`,
                    meal = item,
                    // 餐品的总数量
                    mealAmount = 0,
                    mealSort = Object.keys(this.mealObj).length;
                index = index == undefined ? this.currentBasketIndex : index;
                let mealKey = `${originMealKey}_${index}`;

                // 循环当前的餐品对象
                for (let key in this.mealObj) {
                  // 如果该餐品的key等于mealkey 并且不是分拆类型 则是加数量
                  if (this.mealObj.hasOwnProperty(key) && (key == mealKey)) {
                    type = "plus";
                    meal = this.mealObj[key];
                  }
                  // 统计相同id餐品已有的amount总数
                  let reg = new RegExp(`^${item.meal_id}_`);
                  if (reg.test(key)) {
                    mealAmount += this.mealObj[key].amount;
                  }
                }

                meal['parter'] = item.parter;


                meal.sortIndex = mealSort;
                // 外卖订单  guest_limit为1 且已经存在14件餐品 则不能加入购物车
                if (
                    this.$root.type == "package" &&
                    this.storeDetail.guest_limit > 0 &&
                    this.totalAmount >= this.storeDetail.guest_limit
                ) {
                  this.$msgbox.show({
                    messageText: this.storeDetail.guest_limit_message,
                    confirmBtnText: "我知道了"
                  });
                  return false;
                }

                let hasAmount = 0;
                if (this.baskets[index] && this.baskets[index].mealList) {
                  this.baskets[index].mealList.forEach(v => {
                    hasAmount += v.meal.shp_pct * v.amount;
                  })
                }
                if (hasAmount + item.meal.shp_pct > 1) {
                  // 占碗容量到达上限不再提示错误 放到新篮子中去 ( 只限开启了多篮子 )
                  addToNewBasket = this.enableBasket;
                }
                // else if (hasAmount + item.meal.shp_pct == 1) {
                // 	this.$msgbox.show({
                // 		messageText: "餐盒容量已达上限",
                // 		confirmBtnText: "我知道了"
                // 	});
                // }
                // 	if (
                // 	in_array(meal.category, this.backupArray) &&
                // 		hasAmount > this.backupMax
                // ) {
                // 		this.$msgbox.show({
                // 			messageText:
                // 				"一个订单不得超过 " + this.backupMax + " 个餐品",
                // 			confirmBtnText: "我知道了"
                // 		});
                // 		return false;
                // 	}

                let mealIndex = -1;
                let alreadyHasSplit = false;
                if (this.baskets && this.baskets[index] && this.baskets[index].mealList) {
                  mealIndex = this.baskets[index].mealList.findIndex(v => v.key === mealKey)
                  let isSplit = item.meal.is_split;
                  if (isSplit) {
                    alreadyHasSplit = this.baskets[index].mealList.findIndex(v => v.meal.is_split == 1) > -1;
                  }
                }

                // 如果type是加数量，且当前餐品不存在，则是同一餐品加入了不同篮子
                // 如果当前篮子里已经有其他分拆为1的菜品，则加入新篮子
                if (mealIndex < 0) {
                  type = "addMeal";
                }
                if (alreadyHasSplit || addToNewBasket) {
                  type = "addMeal";
                  index = this.baskets.length;
                  this.currentBasketIndex = index;
                }
                // 篮子从1号开始 todo meal.basket 属性用处已不大 确认后移除
                meal['basket'] = index + 1;

                if (type == "addMeal") {
                  mealKey = `${originMealKey}_${index}`;

                  let mealItem = JSON.parse(JSON.stringify(meal));

                  // 新增商品数量固定为1
                  mealItem.amount = 1;
                  mealItem.key=mealKey;

                  this.$set(this.mealObj, mealKey, mealItem);

                  let list = [];

                  if (this.baskets[index] && this.baskets[index].mealList) {
                    list = this.baskets[index].mealList || [];
                  }

                      // 单品优惠数量
                    Object.keys(mealItem)
                    .filter(key => !['parter', 'basket'].includes(key))
                    .forEach(v => {
                      let tag = [];
                      tag = tag.concat(mealItem.checkedProperty.map(v2 => v2.title));
                      tag = tag.concat(mealItem.checkedParter.map(v2 => v2.name));
                      mealItem.tag = tag.join("/");
                      mealItem.realPrice = parseFloat(
                          (
                              mealItem.price * mealItem.amount +
                              mealItem.parterPropertyPrice * mealItem.amount
                          ).toFixed(2)
                      );
                      // 单品优惠数量
                      mealAmountObj[mealItem.meal_id] = mealItem.meal.rebate_amount;
                    });
                  list.push(mealItem)

                  if (this.baskets[index] && this.baskets[index].mealList) {
                    this.baskets[index].mealList = list;
                  } else {
                    this.baskets[index] = {
                      mealList: list
                    }
                  }

                } else {
                  let newObj = Object.assign({}, this.baskets[index].mealList[mealIndex]);
                  newObj.amount++;

                  newObj.realPrice = parseFloat(
                          (
                              newObj.price * newObj.amount +
                              newObj.parterPropertyPrice * newObj.amount
                          ).toFixed(2)
                      );
                      // 单品优惠数量
                      mealAmountObj[newObj.meal_id] = newObj.meal.rebate_amount;
                    this.mealObj[mealKey] = newObj;
                  this.baskets[index].mealList[mealIndex] = newObj;
                }

                // realPrice 价格重算
                this.baskets.forEach(basket => {
                  let list = basket.mealList;

                    let rebate_count = this.storeDetail.store_rebate_count;
                  list
                    .filter(v => v.hasDiscount)
                    .sort((a, b) => b.discount - a.discount)
                    .map(v => {
                      let useRebate = 0;
                      // 一个id下的所有搭配商品共享一个优惠数量
                      useRebate =
                          v.amount > mealAmountObj[v.meal_id]
                              ? mealAmountObj[v.meal_id]
                              : v.amount;
                      // 如果门店有优惠数量，则最大数量为门店优惠数量
                      if (rebate_count > 0) {
                        if (useRebate > rebate_count) {
                          useRebate = rebate_count;
                          rebate_count = 0;
                        } else {
                          rebate_count -= useRebate;
                        }
                      }
                      // 如果门店优惠数量是0，则使用餐品自身的优惠数量
                      else if (rebate_count == 0) {
                        // 不做操作
                      }
                      // 减去使用了的优惠数量
                      mealAmountObj[v.meal_id] -= useRebate;
                      v.realPrice = parseFloat(
                          (
                              useRebate * v.rebate_price +
                              (v.amount - useRebate) * v.price +
                              v.parterPropertyPrice * v.amount
                          ).toFixed(2)
                      );
                      return v;
                    });
                })

                // 重新赋值 触发更新
                this.baskets = JSON.parse(JSON.stringify(this.baskets));

                $localStorage.set(`baskets_${this.shopOptions.store_id}`, this.baskets);
                $localStorage.set(`currentBasketIndex_${this.shopOptions.store_id}`, this.currentBasketIndex);

                // 当前的总数加1
                mealAmount++;
                // 商品存在优惠，且数量大于等于优惠数量时
                if (
                    meal.hasDiscount &&
                    mealAmount - meal.meal.rebate_amount > 0
                ) {
                  Toast.show(
                      `限${meal.meal.rebate_amount}份优惠，超出以原价计算`
                  );
                } else if (
                    // 餐品存在优惠且门店的优惠数量大于0
                    meal.hasDiscount &&
                    this.storeDetail.store_rebate_count > 0 &&
                    this.storeDetail.new_store_rebate_count < 0
                ) {
                  Toast.show("已超出优惠上限，超出部分以原价计算");
                }
                this.storeDetail.new_store_rebate_count--;
                this.updateStorage();
                this.anchor();
              } else {
                this.$msgbox.show({
                  imageType: MessageBoxImageType.ImgClearCart,
                  messageText: data.errmsg,
                  confirmBtnText: "知道了"
                });
              }
            });
          });
          break;
          // 清除商品
        case "clear":
          this.$msgbox.show({
            imageType: MessageBoxImageType.ImgClearCart,
            messageText: "确认清空购物车？",
            showCancelBtn: true,
            cancelBtnText: "清空",
            confirmBtnText: "取消",
            cancelFn: () => {
              this.clear();
            }
          });
          break;

          // 商品数量减少
        case "sub":
          // 外面展示的数量（多个） 可能被分到了不同的篮子里
          let mealKey = `${item.meal_id}_${item.checkedParterIds ||
          ""}_${item.checkedPropertyIds ||
          ""}_${item.checkedParterPropertyIds || ""}`;

          let enableBasket = this.enableBasket;
          let mealIndex = -1;

          // enableBasket
          if (enableBasket) {
            let originMealKey = mealKey;
            index = index == undefined ? this.currentBasketIndex : index;
            mealKey += `_${index}`;
            // TODO 优化 使用 Map 代替 findIndex
            mealIndex = this.baskets[index].mealList.findIndex(v => v.key === mealKey)
            // 不存在尝试使用 meal_id
            if (mealIndex < 0) {
              mealIndex = this.baskets[index].mealList.findIndex(v => v.meal_id === item.meal_id)
            }
            // 依旧不存在可能是当前 bucket 不存在 全部检查
            if (mealIndex < 0) {
              for (let i = 0; i < this.baskets.length; i++) {
                mealKey = `${originMealKey}_${i}`;
                let basket = this.baskets[i];
                let newIndex = basket.mealList.findIndex(v => v.key === mealKey)
                if (newIndex >= 0) {
                  index = i;
                  mealIndex = newIndex
                  break;
                }
              }
            }
          } else {
            let originMealKey = mealKey;
            for (let i = 0; i < this.baskets.length; i++) {
              let basket = this.baskets[i];
              if (basket && basket.mealList) {
                let mealList = basket.mealList;
                for (let j = 0; j < mealList.length; j++) {
                  let meal = mealList[j];
                  mealKey = `${originMealKey}_${i}`;
                  if (meal.key == mealKey || meal.meal_id === item.meal_id) {
                    index = i;
                    mealIndex = j;
                    break;
                  }
                }
                if (mealIndex > -1) {
                  break;
                }
              }
            }
          }

          if (this.storeDetail.new_store_rebate_count != this.storeDetail.store_rebate_count) {
            this.storeDetail.new_store_rebate_count++;
          }

          let mealAmountObj = {};
          let newObj = {};
          newObj = Object.assign({}, this.baskets[index].mealList[mealIndex]);

          if (newObj.amount == 1) {
            this.$delete(this.mealObj, mealKey);

            this.baskets[index].mealList.splice(this.baskets[index].mealList.findIndex(v => v.key === mealKey), 1)
            this.currentBasketIndex = 0;
            this.updateBaskets();
          } else {
            // let newObj = Object.assign({}, this.mealObj[mealKey]);
            newObj.amount--;
            // 单品优惠数量
            Object.keys(newObj)
                .filter(key => !['parter', 'basket'].includes(key))
                .forEach(v => {
                  let tag = [];

                  tag = tag.concat(newObj.checkedProperty.map(v2 => v2.title));
                  tag = tag.concat(newObj.checkedParter.map(v2 => v2.name));
                  newObj.tag = tag.join("/");
                  newObj.realPrice = parseFloat(
                      (
                          newObj.price * newObj.amount +
                          newObj.parterPropertyPrice * newObj.amount
                      ).toFixed(2)
                  );

                  // 单品优惠数量
                  mealAmountObj[newObj.meal_id] = newObj.meal.rebate_amount;
                });

            this.mealObj[mealKey] = newObj;
            this.baskets[index].mealList[mealIndex] = newObj;
          }

          // realPrice 价格重算
          this.baskets.forEach(basket => {
            let list = basket.mealList;

            let rebate_count = this.storeDetail.store_rebate_count;
            list
                .filter(v => v.hasDiscount)
                .sort((a, b) => b.discount - a.discount)
                .map(v => {
                  let useRebate = 0;
                  // 一个id下的所有搭配商品共享一个优惠数量
                  useRebate =
                      v.amount > mealAmountObj[v.meal_id]
                          ? mealAmountObj[v.meal_id]
                          : v.amount;
                  // 如果门店有优惠数量，则最大数量为门店优惠数量
                  if (rebate_count > 0) {
                    if (useRebate > rebate_count) {
                      useRebate = rebate_count;
                      rebate_count = 0;
                    } else {
                      rebate_count -= useRebate;
                    }
                  }
                  // 如果门店优惠数量是0，则使用餐品自身的优惠数量
                  else if (rebate_count == 0) {
                    // 不做操作
                  }
                  // 减去使用了的优惠数量
                  mealAmountObj[v.meal_id] -= useRebate;
                  v.realPrice = parseFloat(
                      (
                          useRebate * v.rebate_price +
                          (v.amount - useRebate) * v.price +
                          v.parterPropertyPrice * v.amount
                      ).toFixed(2)
                  );
                  return v;
                });
          })
          // 重新赋值 触发更新
          this.baskets = JSON.parse(JSON.stringify(this.baskets));
          $localStorage.set(`baskets_${this.shopOptions.store_id}`, this.baskets);
          $localStorage.set(`currentBasketIndex_${this.shopOptions.store_id}`, this.currentBasketIndex);

          this.updateStorage();
          this.anchor();

          // 如果 baskets 不包含有餐品 不展示
          let totalCount = this.baskets.reduce((sum, item) => {
            return sum + item.mealList.length;
          }, 0);
          if (totalCount == 0) {
            this.hideMealList = true;
          }

          break;
        default:
          break;
      }

    },
    updateStorage() {
      let that = this;
      let mealList = this.baskets.filter(item => item && item.mealList)
                      .map(item => item.mealList)
                      .flat();
      that.storageMap = {}
      mealList.forEach(meal => {
        let mealId = meal.meal.id;
        let amount = meal.amount;
        let oldAmount = that.storageMap[mealId] || 0;
        that.storageMap[mealId] = oldAmount + amount;
      });

      let shopMealObj = $localStorage.get(StoreMealObject) || {};
      shopMealObj[this.shopOptions.store_id] = this.mealObj;
      $localStorage.set(StoreMealObject, shopMealObj);
      this.$root.$emit("updateStorage");
    },
    clear() {
      this.baskets = [{mealList: []}]
      // 还原数据
      this.mealObj = {};
      this.storeDetail.new_store_rebate_count = this.storeDetail.store_rebate_count;
      this.updateStorage();
      this.anchor();
      this.toggleMealList();
      this.currentBasketIndex = 0;
      $localStorage.del('baskets')
      $localStorage.del(`baskets_${this.shopOptions.store_id}`)
      $localStorage.del(`currentBasketIndex_${this.shopOptions.store_id}`)
      this.hideMealList = true;
    },
    loadData() {

      let cacheBasketStr = JSON.stringify($localStorage.get(`baskets_${this.shopOptions.store_id}`));
      let baskets = JSON.parse(cacheBasketStr) || [];

      this.getStoreStatus(true);

      // 过滤所有可能为null 的值
      if (baskets == null)
        baskets = [];
      baskets = baskets.filter(v => v && v.mealList);
      if (baskets.length < 1) {
        baskets = [{mealList: []}];
      }
      let recalcuBasketStr = JSON.stringify(baskets);
      if (cacheBasketStr != recalcuBasketStr) {
        $localStorage.set(`baskets_${this.shopOptions.store_id}`, JSON.parse(JSON.stringify(this.baskets)));
      }
      if (baskets) {
        this.baskets = baskets;
      }
      let currentBasketIndex = $localStorage.get(`currentBasketIndex_${this.shopOptions.store_id}`) || 0;
      if (currentBasketIndex) {
        if (currentBasketIndex >= this.baskets.length) {
          currentBasketIndex = 0;
        }
        this.currentBasketIndex = currentBasketIndex;
      }

      this.storeDetail = $localStorage.get(SelectedStoreDetail) || {};
      this.storeDetail.new_store_rebate_count = this.storeDetail.store_rebate_count;
      this.anchor();

      // 缓存餐品最大库存
      this.mealStorage = this.storeDetail.type_list.flatMap(item => item.meal_list)
          .reduce((acc, meal) => {
            acc[meal.id] = meal.storage;
            return acc;
          }, {});
      this.updateStorage();

      //获取备餐最大数及备餐分类数组
      this.getbackupmax();
      // 详情页不需要弹更换地址
      if (!this.isDetail && this.storeDetail.in_scope == 2) {
        if (this.storeDetail.personal == 0) {
          this.$msgbox.show({
            imageType: MessageBoxImageType.ImgAddressOverArea,
            messageText: "本店超出配送范围，请更换地址",
            confirmBtnText: "更换地址",
            showClose: true,
            confirmFn: () => {
              window.location.href = "address.html";
            }
          });
        } else if (this.storeDetail.personal == 1) {
          // 超出配送范围且允许自提，则自动切换为自提
          this.storeDetail.personal = 2;
          $localStorage.set(SelectedStoreDetail, this.storeDetail);
          let storeShowTakeMessageBox =
                  $localStorage.get(StoreShowTakeMessageBox) || {},
              memberSelectedAddress =
                  $localStorage.get(MemberSelectedAddress) || {};
          let showKey = `${this.shopOptions.store_id}_${memberSelectedAddress.lon
          }_${memberSelectedAddress.lat}`;
          // 如果该门店该经纬度没有提示过则提示
          if (!storeShowTakeMessageBox[showKey]) {
            storeShowTakeMessageBox[showKey] = true;
            $localStorage.set(StoreShowTakeMessageBox, storeShowTakeMessageBox);
            this.$msgbox.show({
              imageType: MessageBoxImageType.ImgAddressOverArea,
              messageText: "本店仅限到店自取，请更换门店或选择自提方式下单",
              showCancelBtn: true,
              cancelBtnText: "更换门店",
              confirmBtnText: "我要自取",
              cancelFn: () => {
                window.history.back();
              }
            });
          }
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/libs.scss";

.basket {
  border-bottom: border();
  padding-top: px2rem(10);
  padding-bottom: px2rem(10);

  &:last-child {
    border: none;
  }
}

.basketHead {
  .basketRadio {
    float: left;
    margin-left: 10px;
  }

  .basketImg {
    float: left;
    margin-left: px2rem(20);
    width: px2rem(30);
    height: px2rem(30);
  }

  .basketText {
    float: left;
    margin-left: px2rem(10);
  }

  .basketTip {
    float: right;
    color: gray;
    font-size: 20px;
  }

  .basketPct {
    float: left;
    margin-left: 20px;
    color: #4052b5;
  }
}

.cart {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  height: px2rem(98);
  z-index: 1000;

  .overlay {
    @include mask-container($fullscreen: true);
  }

  .radio {
    @include square(40);
    border: border(#a6a6a6);
    border-radius: 100%;

    &.selected {
      background: {
        color: #73c6c8;
        image: url("~@/assets/images/checked_white.png");
        size: 100% 100%;
        position: center;
      }

      border-color: #73c6c8;
    }
  }

  .cartList {
    @include square(100%, 400);
    @include pos-a($bottom: 100%);
    transition: all 0.5s;

    &.hide {
      height: 0;
    }

    .message {
      @include pos-a($bottom: 100%);
      @include square(100%, 56);
      border-top: px2rem(1) solid #efe481;
      border-bottom: px2rem(1) solid #efe481;
      background-color: #fdfed2;
      font-size: px2rem(22);
      line-height: px2rem(56);
      color: #545b5b;
      text-align: center;
    }

    .top {
      @include square(100%, 70);
      border-left: px2rem(8) solid #70c6c7;
      padding: 0 px2rem(20) 0 px2rem(12);
      @include dis-flex(center);
      font-size: px2rem(26);
      color: #545b5b;
      background-color: #f6f9f9;
      border-bottom: px2rem(1) solid #e4e4e4;

      .label {
        flex: 1 0 auto;
      }

      .lefttip {
        flex: 1 0 auto;
        font-size: px2rem(26);
        color: #4052b5;
        margin-right: px2rem(35);
      }

      .rubbish {
        display: block;
        width: px2rem(23);
      }

      .clearCart {
        margin-left: px2rem(10);
      }
    }

    .mealObj {
      @include square(100%, 330);
      @extend %overflow-scroll;
      transition: all 0.5s;
      background-color: #ffffff;

      &.hide {
        height: 0;
      }

      .mealItem {
        @include square(100%, 80);
        @include dis-flex(center);
        padding: 0 px2rem(20);
        background-color: #ffffff;

        .name {
          flex: 1 0 auto;
          font-size: px2rem(28);
          color: #545b5b;
          position: relative;

          .label {
            @include pos-a(100%);
            font-size: px2rem(20);
            color: #a6a6a6;
          }
        }

        .lefttip {
          flex: 1 0 auto;
          font-size: px2rem(28);
          color: #4052b5;
          // margin-right: px2rem(30);
        }

        .price {
          font-size: px2rem(28);
          color: #e32351;
          margin-right: px2rem(30);
        }

        .btn {
          @include square(50);
          text-align: center;
          font-size: px2rem(30);
          font-weight: bold;
          border-radius: 100%;

          &.plus {
            background-color: #72c6c8;
            color: white;
          }

          &.sub {
            color: #a6a6a6;
            border: px2rem(1) solid #a6a6a6;
          }
        }

        .num {
          font-size: px2rem(28);
          color: #545b5b;
          margin: 0 px2rem(20);
        }

        // &:not(:last-child) {
        //   //border-bottom: px2rem(1) solid #e4e4e4;
        // }

        &.disabled {

          .name,
          .price,
          .num {
            text-decoration: line-through;
            color: #a6a6a6;
          }

          .btn.plus {
            background-color: #a6a6a6;
            pointer-events: none;
          }
        }
      }
    }
  }

  .cartContainer {
    @include square(100%, 98);
    border-top: px2rem(1) solid #e4e4e4;
    background-color: white;
    @include pos-a(0, 0, 0, 0);
    @include dis-flex;
    z-index: 1000;

    .cartIcon {
      @include square(100);
      border-radius: 100%;
      transform: translate(0, px2rem(-20));
      position: relative;
      margin: 0 px2rem(20);

      background: {
        color: white;
        image: url("~@/assets/images/shop/cart.png");
        size: 100% 100%;
        position: center;
      }

      .count {
        @include pos-a(2, -6);
        @include square(30);
        font-size: px2rem(20);
        line-height: px2rem(30);
        border-radius: 100%;
        background-color: #e1244e;
        color: white;
        text-align: center;
      }
    }

    .priceNode {
      flex: 1 0 auto;
      height: 100%;
      padding: px2rem(20) 0 px2rem(20);
      @include dis-flex(false, space-between);
      flex-direction: column;
      line-height: 1;

      .price {
        font-size: px2rem(32);
        color: #73c6c8;
      }

      .label {
        font-size: px2rem(20);
        color: #7b7f81;

        .through {
          text-decoration: line-through;
        }
      }
    }

    .btn {
      font-size: px2rem(30);
      color: white;
      text-align: center;
      @include square(220, 98);
      line-height: px2rem(98);
      background-color: #72c6c8;
    }

    &.disabled {
      .cartIcon {
        background-image: url("~@/assets/images/shop/cart_disabled.png");
      }

      .priceNode .price {
        color: #a6a6a6;
      }

      .btn {
        background-color: #a6a6a6;
        pointer-events: none;
      }
    }
  }

  .error {
    @include square(100%, 98);
    background-color: #d2d6d6;
    color: #545b5b;
    font-size: px2rem(32);
    line-height: px2rem(98);
    text-align: center;
  }
}
</style>
